import React from 'react';
import queryString from 'query-string';
import { IonContent, IonPage } from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { Empty, Filter, Header, Item, TabsOffset } from 'components';
import { axius, func, types } from 'utils';
import _ from 'lodash';
import { _store, _update } from '_Store';
import ItemBottomModal from '../components/ItemBottmModal';

interface Props extends RouteComponentProps, types.StateProps {}
const Search: React.FC<Props> = (props) => {
	const limit = 12;

	const {
		__data: { filter, location, activeStore, categories },
	} = _store.useState();

	const [step, setStep] = React.useState({ items: 0, stores: 0 });
	const [data, setData] = React.useState({ items: [], stores: [] });
	const [bigData, setBigData] = React.useState({ items: [], stores: [] });
	const [loading, setLoading] = React.useState(true);
	const [isItemModalOpen, setOpenedItemModal] = React.useState(false);
	const [selectProduct, setSelectProduct] = React.useState<types.Item>();
	const [results, setResults] = React.useState({
		total: 0,
		items: 0,
		stores: 0,
	});

	let qs = queryString.parse(props.history.location.search);

	React.useEffect(() => {
		getData();
		// window['$'](`#carousel-category-filters`).owlCarousel(owlCarouselOptions);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [props.history.location.search, filter]);

	const getData = () => {
		setLoading(true);
		setResults({ total: 0, items: 0, stores: 0 });
		setData({ items: [], stores: [] });
		const categoryUUID = qs.category
			? categories.find((ctg) => ctg.id === qs.category)?.id
			: '';
		axius
			.post('search', {
				tags: !qs.q ? filter.tags || [] : [],
				city: location.address.city,
				stores: [activeStore.code],
				keyword: qs.q || '',
				minPrice: !qs.q
					? _.isEmpty(filter.minPrice)
						? undefined
						: +(filter.minPrice ? filter.minPrice.toString() : '').replace(
								',',
								''
							)
					: 0,
				maxPrice: !qs.q
					? _.isEmpty(filter.maxPrice)
						? undefined
						: +(filter.maxPrice ? filter.maxPrice.toString() : '').replace(
								',',
								''
							)
					: 9999999999999999,
				deliveryOptions: [location.option],
				latitude: location.address.x,
				longitude: location.address.y,
				resultTypes: ['items'],
				categories: categoryUUID ? [categoryUUID] : [],
			})
			.then((res) => {
				if (res.status === 201) {
					const q = ((qs.q as string) || '').toLowerCase();
					const items = [
						...res.items.filter((i: types.Item) =>
							i.name.toLowerCase().includes(q)
						),
						...res.items.filter(
							(i: types.Item) => !i.name.toLowerCase().includes(q)
						),
					];
					var cData = {
						items: func.chunk(
							items
								.map((item: types.Item) => {
									return {
										...item,
										distance: +func.distanceMatrix(
											{
												lat: location?.address?.x,
												lng: location?.address?.y,
											},
											{
												lat: activeStore.address.x,
												lng: activeStore.address.y,
											},
											true
										),
									};
								})
								// .sort((a: types.Item3, b: types.Item3) => (a.distance > b.distance) ? 1 : -1)
								.filter(
									(item: types.Item) =>
										item.status === types.ItemStatuses.PUBLISHED
								)
								.filter((item: types.Item) =>
									location.option === types.OrderTypes.DELIVERY
										? item.canDeliver && item.categories[0]?.canDeliver
										: item
								),
							limit
						),
						stores: [],
					};
					setBigData(cData);
					setData({
						items: cData.items[0] || [],
						stores: cData.stores[0] || [],
					});
					setResults({
						total: cData.items.flat().length + cData.stores.flat().length,
						items: cData.items.flat().length,
						stores: cData.stores.flat().length,
					});
				}
				setLoading(false);
			});
	};

	const getNext = (key: string) => {
		const newStep = JSON.parse(JSON.stringify(step));
		const newData = JSON.parse(JSON.stringify(data));
		const newBigData = JSON.parse(JSON.stringify(bigData));

		setData({
			...data,
			[key]: newData[key].concat(newBigData[key][newStep[key] + 1] || []),
		});

		newStep[key] = newStep[key] + 1;
		setStep(newStep);
	};

	return (
		<IonPage id="Search">
			<Header {...props} showSearch={true} showSegments={false} />
			<IonContent fullscreen={false}>
				<div id="SearchScreen" className="content">
					<Filter {...props} categories={[]} />
					<div className="mt-0 px-3">
						{loading &&
							func
								.generateOptions(limit)
								.map((i) => (
									<div
										key={i}
										className="skeleton my-2"
										style={{ borderRadius: 7, height: 108 }}
									/>
								))}

						{!loading && results.items === 0 && (
							<Empty
								style={{}}
								text={
									<div>
										No results for "<b>{qs.q}</b>" here,
										<br /> try something else.
									</div>
								}
							/>
						)}

						{!loading && results.total > 0 && (
							<div>
								<div>&nbsp;</div>
								{!loading && (
									<div className="small fw-500s mb-3 text-muted">
										{results.total > 0
											? func.numberFormat(results.total, 2)
											: 'No'}{' '}
										results found for "{qs.q}"
									</div>
								)}

								{!loading &&
									data.items.length > 0 &&
									data.items.map(
										(item: types.Item) =>
											item.status === types.ItemStatuses.PUBLISHED && (
												<div key={item.id} className="mb-4s">
													<Item
														{...props}
														item={item}
														layout="list"
														description={true}
														handleSelectedItem={(item) => {
															setSelectProduct(item);
															setOpenedItemModal(true);
															_update.data('is_bottom_modal', {
																is_open: true,
															});
														}}
													/>
												</div>
											)
									)}

								{results.items > data.items.length && (
									<div
										className="text-center pointer small"
										onClick={() => getNext('items')}
									>
										load more
									</div>
								)}
							</div>
						)}
					</div>
					{selectProduct && (
						<ItemBottomModal
							isItemModalOpen={isItemModalOpen}
							setOpenedItemModal={setOpenedItemModal}
							selectedProduct={selectProduct}
						/>
					)}{' '}
				</div>
				<TabsOffset />
			</IonContent>
		</IonPage>
	);
};

export default Search;
